export const i18nData = {
  es: {
    meta: {
      title: "Salo Trading 24 | Empresa Líder en Comercio Internacional y Soluciones Globales",
      description: "Fundada en 2009 por Menahem Truzman. Importación, comercialización y distribución internacional en alimentos, salud, deportes, tecnología, ferretería y servicios. Sedes en Caracas y Miami."
    },
    nav: {
      home: "Inicio",
      about: "¿Quiénes Somos?",
      structure: "Estructura",
      csr: "Responsabilidad RSE",
      sectors: "Sectores",
      markets: "Mercados",
      suppliers: "Proveedores",
      insights: "Publicaciones",
      contact: "Contacto",
      sitemap: "Sitemap Rectificado",
      langToggle: "EN",
      flyoutAboutBadge: "PERFIL CORPORATIVO",
      flyoutAboutMeta: "Desde 2009 · Menahem Truzman",
      flyoutHistoryTitle: "Historia y Fundación",
      flyoutHistoryDesc: "Fundada en 2009 para el comercio de bienes de lícito comercio.",
      flyoutStructTitle: "Estructura Organizacional",
      flyoutStructDesc: "Presidencia y departamentos de compras, comercialización y administración.",
      flyoutCsrTitle: "Responsabilidad Social (RSE)",
      flyoutCsrDesc: "Pirámide de 5 niveles de cumplimiento ético y sustentabilidad.",
      flyoutHqsTitle: "Sedes Caracas & Miami",
      flyoutHqsDesc: "CC Galerías Sebucán en Caracas y oficina de enlace en Florida.",
      flyoutSectorsBadge: "7 LÍNEAS DE COMERCIALIZACIÓN",
      flyoutSectorsMeta: "100% Bienes de Lícito Comercio",
      flyoutFood: "Alimentos",
      flyoutHealth: "Salud",
      flyoutSports: "Deportes",
      flyoutLogistics: "Logística",
      flyoutHardware: "Ferretería",
      flyoutServices: "Servicios",
      flyoutTech: "Tecnología"
    },
    topbar: {
      phone: "+58 414 124 5080",
      email: "info@salotrading24.com",
      instagram: "Síguenos en Instagram",
      hqBadge: "Caracas & Miami",
      schedule: "Lun - Vie: 8:00 AM - 5:00 PM",
      corpBadge: "Distribución & Comercialización Mayorista",
      switchLangText: "English",
      navCta: "Iniciar Negociación"
    },
    hero: {
      badge: "TRAYECTORIA COMERCIAL DESDE 2009",
      headlinePrefix: "Comercio Global,",
      headlineHighlight: "Soluciones Estratégicas",
      subheadline: "SALO TRADING 24 conecta mercados de alta exigencia comercializando bienes de lícito comercio en sectores clave con presencia en América, Asia, África y Medio Oriente.",
      ctaPrimary: "Iniciar Negociaciones",
      ctaSecondary: "Conocer la Organización",
      mapTitle: "Rutas de Suministro Global",
      mapSub: "RED LOGÍSTICA TRANSCONTINENTAL",
      stats: [
        { value: "2009", label: "Año de Fundación", sub: "Más de 17 años de operaciones" },
        { value: "6", label: "Mercados Globales", sub: "América, Asia, África y Medio Oriente" },
        { value: "35+", label: "Marcas y Aliados", sub: "Duracell, Gillette, P&G, Nestlé y más" },
        { value: "100%", label: "Comercio Lícito", sub: "Estrictos estándares de cumplimiento" }
      ],
      nodes: {
        caracas: { name: "Caracas (Sede Principal)", desc: "Hub corporativo y centro de distribución para Venezuela y El Caribe." },
        miami: { name: "Miami (Oficina de Representación)", desc: "Hub de coordinación logística para Norteamérica y comercio global." },
        canada: { name: "Canadá", desc: "Intercambio bilateral de bienes de consumo y tecnología industrial." },
        eastAsia: { name: "Este de Asia (Japón / Corea)", desc: "Alianzas de suministro electrónico y manufactura de alta gama." },
        southeastAsia: { name: "Sudeste Asiático", desc: "Sourcing directo de componentes, hardware y productos masivos." },
        middleEast: { name: "Medio Oriente", desc: "Centro financiero transcontinental y distribución de commodities." },
        africa: { name: "África", desc: "Intercambio en mercados emergentes y bienes de consumo." }
      }
    },
    about: {
      badge: "PERFIL CORPORATIVO",
      title: "¿Quiénes Somos?",
      leadParagraph: "SALO TRADING 24 comienza sus operaciones en el año 2009, cuando nuestro Presidente, Menahem Truzman, funda la organización con el objetivo de comercializar todo tipo de productos en los sectores alimenticio, servicios, salud, deportes, transporte, ferretería y otros, todos de lícito comercio.",
      locationsTitle: "Sedes y Cobertura Internacional",
      locationsDesc: "Nuestra sede principal está en Caracas, Venezuela. Contamos con una oficina de representación estratégica en Miami, USA.",
      hqCard: {
        title: "Sede Principal (Caracas)",
        address: "CC Galerías Sebucán, Terraza 2, local 3. Transversal 10 con Av. Los Chorros, Urb. Los Dos Caminos. Caracas 1071, Venezuela.",
        badge: "Sede Corporativa Central",
        base: "Base de Distribución: Venezuela y el Caribe"
      },
      miamiCard: {
        title: "Oficina de Representación (Miami)",
        address: "Miami, Florida, Estados Unidos. Hub de coordinación para el hemisferio norte y comercio transatlántico.",
        badge: "Hub Logístico Norteamérica",
        base: "Aliados en Norteamérica: Estados Unidos y Canadá"
      },
      pillarsTitle: "Perfil Estratégico de la Empresa",
      missionTitle: "Misión",
      missionDesc: "Brindar servicios y soluciones que satisfagan las necesidades de nuestros clientes de manera eficiente.",
      visionTitle: "Visión",
      visionDesc: "Posicionarnos dentro de los principales importadores de bienes y servicios para Venezuela y el Caribe, mediante alianzas estratégicas con fabricantes y proveedores de productos elaborados bajo estrictos criterios de excelencia y altos estándares de calidad.",
      valuesTitle: "Valores Éticos",
      values: [
        { title: "Conducta Ética", desc: "Integridad, honestidad, compromiso y responsabilidad en cada operación." },
        { title: "Satisfacción del Cliente", desc: "Enfoque constante en superar las expectativas de nuestros compradores y aliados." },
        { title: "Orientación al Logro", desc: "Compromiso absoluto con la calidad, la eficiencia y los protocolos de seguridad." },
        { title: "Trabajo en Equipo", desc: "Sinergia colaborativa entre colaboradores, socios comerciales y proveedores." },
        { title: "Responsabilidad Social", desc: "Compromiso con nuestros colaboradores, las comunidades locales y el medio ambiente." }
      ]
    },
    structure: {
      badge: "GOBERNANZA Y OPERACIONES",
      title: "Estructura Organizacional",
      subtitle: "Un modelo de liderazgo dinámico y centralizado enfocado en la agilidad comercial y la excelencia operativa.",
      modalPrompt: "Haga clic en cada área para consultar sus responsabilidades corporativas.",
      president: {
        badge: "Dirección General",
        role: "Presidente y Fundador",
        name: "Menahem Truzman",
        desc: "Fundador y líder estratégico de SALO TRADING 24 desde 2009. Dirección general de relaciones internacionales y alianzas globales.",
        details: "Liderazgo en la toma de decisiones estratégicas, negociación de alianzas con multinacionales, gobernanza corporativa y supervisión integral del plan de expansión en América y ultramar."
      },
      assistant: {
        role: "Asistente de Presidencia",
        desc: "Coordinación ejecutiva, enlace institucional y seguimiento de resoluciones de alta gerencia.",
        details: "Gestión de agenda bilateral, comunicación fluida con oficinas de representación en Miami y Caracas, seguimiento de acuerdos y auditoría operativa."
      },
      departments: [
        {
          role: "Compras",
          title: "Compras Internacionales",
          desc: "Negociación con fabricantes mundiales, sourcing de materias primas y productos terminados, logística aduanal y control de suministros.",
          details: "Evaluación de proveedores de primer nivel (Duracell, Gillette, P&G, Nestlé, Sony), trámites arancelarios, verificación de calidad en origen y gestión de fletes internacionales marítimos y aéreos."
        },
        {
          role: "Ventas",
          title: "Ventas y Comercialización",
          desc: "Distribución nacional e internacional, apertura de canales comerciales, fidelización y atención corporativa de clientes.",
          details: "Colocación estratégica en cadenas de retail, mayoristas y distribuidores institucionales en Venezuela y el Caribe, atención postventa y desarrollo de nuevos mercados."
        },
        {
          role: "Administración",
          title: "Administración y Finanzas",
          desc: "Gestión contable, tesorería, cumplimiento tributario, auditoría legal y optimización de flujos de capital.",
          details: "Cumplimiento estricto de marcos legales y fiscales nacionales e internacionales, control cambiario, auditorías contables independientes y administración de recursos humanos."
        }
      ]
    },
    csr: {
      badge: "RESPONSABILIDAD SOCIAL CORPORATIVA",
      title: "Política de Responsabilidad",
      lead: "Creemos firmemente que SALO TRADING 24 puede y debe tener un impacto positivo en las comunidades a las que servimos. Es nuestra visión de que juntos elevaremos a nuestros socios, clientes, proveedores y vecinos a crear un cambio positivo en las áreas en las que podemos tener el mayor impacto:",
      focusAreas: [
        {
          icon: "leaf",
          title: "Liderar en sostenibilidad",
          desc: "Nuestra aspiración es convertirnos en recursos positivos, dando más de lo que tomamos a través de prácticas éticas."
        },
        {
          icon: "users",
          title: "Fortalecimiento de las comunidades",
          desc: "Buscamos ser un lugar acogedor para todos, impulsando el voluntariado en nuestros vecindarios para ayudar a las familias."
        },
        {
          icon: "sparkles",
          title: "Creación de oportunidades",
          desc: "Invertimos en caminos hacia las oportunidades a través de la educación, formación y empleo, apoyando a nuestro talento a construir su futuro."
        }
      ],
      pyramidTitle: "Pirámide Jerárquica de Responsabilidad Social",
      pyramidSubtitle: "Estructura de compromiso ético e impacto socioeconómico (Basada en las políticas oficiales)",
      pyramidLevels: [
        {
          level: 5,
          tier: "Nivel 5 (Cúspide)",
          name: "Diseño / Ejecución Políticas de Estado",
          desc: "Alineación estratégica con políticas macroeconómicas, seguridad alimentaria, desarrollo productivo y aporte a planes nacionales de desarrollo e infraestructura comercial.",
          color: "#E28B00"
        },
        {
          level: 4,
          tier: "Nivel 4",
          name: "Proyección Comunidad",
          desc: "Iniciativas de impacto directo en el entorno social: voluntariado corporativo, donaciones benéficas, fomento comunitario y alianzas con centros locales de formación.",
          color: "#F2B822"
        },
        {
          level: 3,
          tier: "Nivel 3",
          name: "Proyección Familia",
          desc: "Programas de bienestar extendido para el núcleo familiar de nuestros colaboradores: salud preventiva, becas formativas y estabilidad económica.",
          color: "#F6D638"
        },
        {
          level: 2,
          tier: "Nivel 2",
          name: "Desarrollo de la Persona",
          desc: "Capacitación continua, ergonomía laboral, crecimiento profesional, respeto irrestricto a los derechos del trabajador y fomento del liderazgo interno.",
          color: "#29B6F6"
        },
        {
          level: 1,
          tier: "Nivel 1 (Base Fundamental)",
          name: "Cumplimiento del Régimen Legal",
          desc: "La base indeclinable de todas nuestras operaciones: legalidad absoluta, transparencia tributaria, aduanal, licencias comerciales y estricto apego al marco normativo vigente.",
          color: "#0288D1"
        }
      ]
    },
    sectors: {
      badge: "DIVERSIFICACIÓN COMERCIAL",
      title: "Sectores de Negocio",
      subtitle: "Comercializamos una amplia gama de productos de alta demanda y lícito comercio en siete sectores estratégicos:",
      verifiedBadge: "Comercio Lícito Garantizado",
      items: [
        {
          code: "01",
          name: "Sector Alimenticio",
          desc: "Comestibles, bebidas, enlatados, abarrotes y productos de consumo masivo con marcas globales reconocidas por su frescura y calidad nutricional.",
          icon: "shopping-bag"
        },
        {
          code: "02",
          name: "Sector Salud",
          desc: "Insumos hospitalarios, material médico-quirúrgico, equipamiento de diagnóstico y productos de higiene y cuidado personal.",
          icon: "heart-pulse"
        },
        {
          code: "03",
          name: "Sector Deportes",
          desc: "Artículos deportivos, calzado, indumentaria, balonería y accesorios de alto rendimiento para atletas y entusiastas.",
          icon: "trophy"
        },
        {
          code: "04",
          name: "Sector Transporte",
          desc: "Repuestos, componentes automotrices, consumibles mecánicos y logística de distribución especializada para flotas.",
          icon: "truck"
        },
        {
          code: "05",
          name: "Sector Ferretería",
          desc: "Herramientas manuales y eléctricas, tornillería, materiales de construcción, cables y suministros para la industria y el hogar.",
          icon: "wrench"
        },
        {
          code: "06",
          name: "Servicios Corporativos",
          desc: "Soluciones de intermediación mercantil, asesoría aduanera, compras internacionales y gestión integral de cadenas de suministro.",
          icon: "briefcase"
        },
        {
          code: "07",
          name: "Tecnología y Electrónica",
          desc: "Audio, video, electrodomésticos, dispositivos inteligentes e imagen digital de vanguardia tecnológica.",
          icon: "tv"
        }
      ]
    },
    markets: {
      badge: "ALCANCE INTERNACIONAL",
      title: "Mercados Principales y Presencia Global",
      subtitle: "Rutas de importación, distribución y vínculos estratégicos en cuatro continentes:",
      alliesNorthAmericaTitle: "Tus Aliados en Norteamérica",
      alliesNorthAmericaDesc: "Conexión directa con Estados Unidos y Canadá, facilitando el acceso a centros de distribución y fabricantes líderes en el hemisferio norte.",
      southAmericaTitle: "También Estamos en Suramérica",
      southAmericaDesc: "Nuestra base de operaciones principal en Caracas, Venezuela, sirviendo como plataforma de distribución y logística para la región andina y el Caribe.",
      routesBadgeNorth: "USA ⇄ CANADÁ ⇄ LATAM",
      routesBadgeSouth: "VENEZUELA & EL CARIBE",
      regions: [
        { name: "Canadá", desc: "Intercambio comercial, bienes de consumo e insumos industriales.", code: "CA" },
        { name: "América del Sur", desc: "Hub de operaciones en Venezuela y alcance al Caribe.", code: "SA" },
        { name: "Sudeste de Asia", desc: "Manufactura avanzada, tecnología y componentes electrónicos.", code: "SEA" },
        { name: "África", desc: "Mercados emergentes, intercambio de materias primas y productos de consumo.", code: "AF" },
        { name: "Medio Oriente", desc: "Hubs logísticos transcontinentales y centros financieros de comercio.", code: "ME" },
        { name: "Este de Asia", desc: "Alianzas con gigantes industriales en Japón, Corea y centros de producción.", code: "EA" }
      ]
    },
    suppliers: {
      badge: "ECOSISTEMA DE PROVEEDORES",
      title: "Nuestros Proveedores y Marcas",
      statement: "Hemos mantenido relaciones comerciales exitosas con Duracell y con Gillette de Venezuela. Nuestro plan de expansión contempla ampliar estos vínculos, en ese sentido, iniciamos contacto con grandes comercializadoras locales e internacionales las cuales manejan productos de marcas como: Nestlé, Del Monte, Procter & Gamble, Fuji, JBL, Nike, Adidas, Canon, Crayola, entre muchas otras.",
      tickerTitle: "MARCAS Y ALIANZAS GLOBALES EN NUESTRO PORTAFOLIO",
      allBrands: [
        "Duracell", "Gillette de Venezuela", "Procter & Gamble", "Nestlé", "Del Monte",
        "Sony", "Canon", "Nikon", "JBL", "Panasonic", "Philips", "Apple", "Dell",
        "Bose", "Samsung", "LG Electronics", "Nike", "Adidas", "Bosch", "Caterpillar",
        "Fujifilm", "Toshiba", "Hisense", "Casio", "Yamaha", "Crayola", "Pioneer",
        "Polaroid", "Denon", "Kenwood", "Olympus", "Westinghouse", "Harman/Kardon"
      ]
    },
    blog: {
      badge: "PUBLICACIONES Y ANÁLISIS",
      title: "Publicaciones",
      subtitle: "Cobertura tecnológica, informes de ferias internacionales y tendencias del mercado global.",
      categoryTag: "Tendencias y Tecnología",
      readArticle: "Leer Artículo Completo",
      post: {
        date: "13 de diciembre de 2021",
        title: "Novedades de la CES 2021",
        excerpt: "El primer CES® 2021, totalmente digital, abrió su experiencia virtual completa a audiencias de todo el mundo mostrando de primera mano la innovación y las tecnologías globales.",
        introP1: "El primer CES® 2021, totalmente digital, abrió su experiencia virtual completa a audiencias de todo el mundo mostrando al público de primera mano la innovación y las tecnologías que harán avanzar a todo el planeta.",
        introP2: "CES 2021 contó con más de 1900 expositores que representan todo el espectro tecnológico y más de 100 sesiones de conferencias de líderes de la industria que comparten visiones para un futuro mejor.",
        subheading: "Novedades más relevantes presentadas por algunas de las marcas participantes:",
        brandsList: [
          { name: "Bosch", desc: "Mostró compromisos con la sostenibilidad como la primera empresa industrial global en convertirse en carbono neutral e introdujo un rastreador de fitness portátil habilitado con inteligencia artificial que reconoce y registra cualquier tipo de actividad física que se base en patrones repetitivos." },
          { name: "Canon", desc: "Proporcionó un adelanto de los planes de la empresa más allá de las cámaras e impresoras, incluida la redefinición de la visión del planeta, el skateboard y la lucha contra el desperdicio de alimentos." },
          { name: "Caterpillar", desc: "Compartió la primera aplicación de comando para los camiones mineros autónomos de Caterpillar y la tecnología innovadora en las condiciones más desafiantes." },
          { name: "Hisense", desc: "Anunció la línea de televisores láser TriChroma 2021." },
          { name: "Indy Autonomous Challenge", desc: "Se presentó el primer auto de carreras autónomo del mundo, que se utilizará en el Indy Autonomous Challenge, donde más de 500 estudiantes universitarios están desarrollando la tecnología para conducir el auto de carreras y ganar la competencia por un premio de $ 1.5 millones." },
          { name: "Intel / Mobileye", desc: "Anunciaron noticias compartidas sobre el futuro de la movilidad para Mobileye, incluidos planes para abrir centros de implementación en Shanghái, Tokio, París y Detroit, y utilizar sensores lidar construidos en casa." },
          { name: "Kohler", desc: "Introdujo un grifo de cocina para montaje en techo con control táctil simple; así como un monitor de agua para toda la casa que se instala debajo de los gabinetes. También se presentó un nuevo inodoro inteligente, grifos de baño sin contacto, entre otros." },
          { name: "LG Electronics", desc: "Anunció la próxima generación de la línea LG PuriCare™ para soluciones de gestión del aire de alta calidad; refrigerador de dos puertas reinventado con Crafted Ice; WashTower™ con inteligencia incorporada; líneas OLED evo y QNED MiniLED, y el robot CLOi UV-C para desinfección." },
          { name: "Magna International", desc: "Anunció una alianza estratégica con LG Electronics para fabricar motores electrónicos y otros sistemas de transmisión electrónica para fabricantes de automóviles, respaldando el cambio global hacia la electrificación." },
          { name: "Mercedes-Benz", desc: "Mostró la Hyperscreen MBUX, que utiliza IA para ofrecer una experiencia intuitiva para el conductor y el pasajero." },
          { name: "OMRON Healthcare", desc: "Anunció VitalSight, el primer servicio de monitoreo remoto de pacientes diseñado específicamente para el manejo de la hipertensión." },
          { name: "Panasonic", desc: "Anunció una asociación tecnológica con Illuminarium Experiences para dar vida a nuevos centros de entretenimiento inmersivo de 360 grados y lanzó el televisor OLED JZ2000." },
          { name: "Philips", desc: "Presentó su visión en tecnología de salud y anunció el cepillo Philips Sonicare 9900 Prestige con tecnología SenseIQ e inteligencia artificial." },
          { name: "Samsung Electronics", desc: "Anunció el refrigerador Flex Bespoke de 4 puertas personalizable, el robot JetBot 90 AI+, embalaje ecológico y su programa Galaxy Upcycling at Home." },
          { name: "Schneider Electric", desc: "Presentó el Square D Energy Center, interruptores conectados Square D y Acti9 Active para gestión integral de energía en el hogar." },
          { name: "Skyworth", desc: "Presentó su línea de televisores para América del Norte con cinco series compuestas por 16 modelos diferentes." },
          { name: "Sony", desc: "Presentó Airpeak (dron con IA y robótica para creadores) y una vista previa del concierto de realidad virtual inmersiva en Sony PlayStation VR." },
          { name: "Taiwan Tech Arena", desc: "Destacó a 100 equipos de startups en Smart Living, Tech for Good, Ciberseguridad, Salud y Movilidad." },
          { name: "TCL", desc: "Anunció la tecnología OD Zero™ Mini-LED, el primer Google TV de TCL, tabletas NXTPAPER, auriculares MOVEAUDIO S600 y la serie de teléfonos TCL 20 con 5G." }
        ]
      }
    },
    contact: {
      badge: "CANALES DE COMUNICACIÓN",
      title: "Contacto y Sedes",
      subtitle: "¿Listo para iniciar negocios? Comuníquese directamente con nuestro equipo de gerencia comercial.",
      formTitle: "Ponte en Contacto con Nosotros",
      nameLabel: "Nombre Completo / Empresa *",
      namePlaceholder: "Ingrese su nombre o el de su empresa",
      emailLabel: "Correo Electrónico Corporativo *",
      emailPlaceholder: "su.correo@empresa.com",
      phoneLabel: "Teléfono / WhatsApp",
      phonePlaceholder: "+58 414 000 0000",
      subjectLabel: "Asunto / Sector de Interés",
      subjectOptions: [
        "Comercialización de Alimentos",
        "Sector Salud y Médico",
        "Tecnología y Electrónica",
        "Sector Deportes y Calzado",
        "Transporte y Ferretería",
        "Alianzas de Proveedores",
        "Otra Consulta Comercial"
      ],
      messageLabel: "Mensaje *",
      messagePlaceholder: "Describa su requerimiento comercial, volumen estimado o propuesta...",
      submitBtn: "Enviar Mensaje",
      sendingBtn: "Procesando envío...",
      successMsg: "¡Gracias por contactar a Salo Trading 24! Su mensaje ha sido procesado exitosamente. Le responderemos a la brevedad.",
      cards: {
        hqTitle: "Sede Principal (Caracas)",
        hqAddress: "CC Galerías Sebucán, Terraza 2, local 3. Transversal 10 con Av. Los Chorros, Urb. Los Dos Caminos. Caracas 1071, Venezuela.",
        miamiTitle: "Oficina de Representación (Miami)",
        miamiAddress: "Miami, Florida, Estados Unidos.",
        phoneTitle: "Línea Telefónica Directa",
        phoneValue: "+58 414 124 5080",
        emailTitle: "Correo Electrónico",
        emailValue: "info@salotrading24.com",
        instagramTitle: "Redes Sociales",
        instagramValue: "@salotrading24",
        whatsappBtn: "Contactar por WhatsApp Directo",
        mapsLinkText: "Ver en Google Maps"
      },
      floatingWhatsApp: "¿Desea cotizar? Hablemos por WhatsApp"
    },
    sitemapAudit: {
      badge: "AUDITORÍA TÉCNICA Y ESTRUCTURA RECTIFICADA",
      title: "Rectificación Integral del Sitemap",
      subtitle: "Sustitución de la estructura desactualizada de WordPress por una arquitectura canónica bilingüe 2026 limpia y de alto rendimiento.",
      comparisonTitle: "Diagnóstico vs. Solución Implementada",
      legacyColTitle: "Sitemap Anterior (WordPress 2019-2021) [Depurado]",
      legacyIssues: [
        "Más de 60 URLs basura provenientes del demo del theme Impreza (/elements/accordion, /portfolio-grid-4, /shop-without-sidebar, /tablepress-tables, /pagina-ejemplo).",
        "Subdominio en.salotrading24.com desarticulado con meta 'noindex' duplicada e inconsistente.",
        "Ausencia de marcado estructurado Schema.org canónico.",
        "Falta de indexación unificada de los sectores de negocio reales de la empresa."
      ],
      rectifiedColTitle: "Sitemap Rectificado 2026 [Producción]",
      rectifiedFeatures: [
        "Arquitectura canónica 100% libre de demos: exactamente 7 rutas maestras en Español e Inglés.",
        "Implementación de directivas hreflang (es, en, x-default) para SEO multi-región impecable.",
        "Sitemap.xml y robots.txt válidos generados en la raíz pública.",
        "Todas las secciones originales conservadas e integradas en una experiencia fluida sin dependencias obsoletas."
      ],
      canonicalUrlsTitle: "Rutas Maestras Rectificadas",
      table: [
        { route: "/", descEs: "Inicio / Visión General de Salo Trading 24", descEn: "Home / Executive Overview", priority: "1.0" },
        { route: "/quienes-somos", descEs: "¿Quiénes Somos?, Historia, Sedes, Misión, Visión, Valores", descEn: "About Us, Origins, HQ, Mission, Vision, Values", priority: "0.9" },
        { route: "/quienes-somos#estructura", descEs: "Organigrama y Estructura Operativa", descEn: "Governance & Organizational Chart", priority: "0.85" },
        { route: "/quienes-somos#responsabilidad", descEs: "Política RSE y Pirámide de 5 Niveles", descEn: "CSR Policy & 5-Tier Pyramid", priority: "0.85" },
        { route: "/sectores", descEs: "7 Sectores Comerciales y Bienes de Lícito Comercio", descEn: "7 Business Sectors & Legal Commerce Goods", priority: "0.85" },
        { route: "/mercados", descEs: "6 Mercados Globales y Alianzas Norte/Suramérica", descEn: "6 Global Markets & Continental Alliances", priority: "0.85" },
        { route: "/proveedores", descEs: "Ecosistema de 35+ Marcas y Relaciones Comerciales", descEn: "Brand Ecosystem & Commercial Network", priority: "0.8" },
        { route: "/publicaciones", descEs: "Publicaciones / Novedades CES 2021 Completo", descEn: "Insights / CES 2021 Tech Report", priority: "0.75" },
        { route: "/contacto", descEs: "Sedes Caracas y Miami, Formulario y WhatsApp", descEn: "Caracas HQ, Miami Office, Contact Portal", priority: "0.9" },
        { route: "/sitemap.xml", descEs: "Archivo XML de Indexación para Motores de Búsqueda", descEn: "Search Engine Canonical XML Index", priority: "N/A" }
      ],
      xmlBtn: "Ver sitemap.xml Oficial",
      robotsBtn: "Ver robots.txt Oficial"
    },
    footer: {
      tagline: "Empresa líder en comercio internacional y distribución de bienes de lícito comercio. Fundada en 2009 por Menahem Truzman.",
      quickLinksTitle: "Navegación Rápida",
      companyTitle: "La Organización",
      contactTitle: "Atención al Cliente",
      legalTitle: "Garantía de Comercio Lícito",
      legalText: "SALO TRADING 24 opera bajo los más rigurosos estándares de cumplimiento aduanero, tributario y de legalidad mercantil internacional.",
      copyright: "© 2009 - 2026 SALO TRADING 24. Todos los derechos reservados.",
      devCredit: "Rediseñado con estándar editorial de 2026. Preservando el 100% del contenido original.",
      complianceBadge: "Compliance Verificado 2026"
    }
  },
  en: {
    meta: {
      title: "Salo Trading 24 | Leading Global Trading & International Commerce Firm",
      description: "Founded in 2009 by President Menahem Truzman. Global distribution and commercialization across food, health, sports, tech, hardware, and corporate services. Offices in Caracas and Miami."
    },
    nav: {
      home: "Home",
      about: "About Us",
      structure: "Structure",
      csr: "CSR Responsibility",
      sectors: "Sectors",
      markets: "Markets",
      suppliers: "Suppliers",
      insights: "Insights",
      contact: "Contact",
      sitemap: "Rectified Sitemap",
      langToggle: "ES",
      flyoutAboutBadge: "CORPORATE PROFILE",
      flyoutAboutMeta: "Since 2009 · Menahem Truzman",
      flyoutHistoryTitle: "History & Foundation",
      flyoutHistoryDesc: "Founded in 2009 for international trade of strictly legal goods.",
      flyoutStructTitle: "Organizational Structure",
      flyoutStructDesc: "Executive Presidency, procurement, sales, and administrative divisions.",
      flyoutCsrTitle: "Social Responsibility (CSR)",
      flyoutCsrDesc: "5-Tier pyramid of ethical governance and sustainable development.",
      flyoutHqsTitle: "Caracas & Miami Hubs",
      flyoutHqsDesc: "CC Galerías Sebucán in Caracas & liaison hub in Florida.",
      flyoutSectorsBadge: "7 COMMERCIAL DIVISIONS",
      flyoutSectorsMeta: "100% Strictly Legal Goods",
      flyoutFood: "Food & Beverage",
      flyoutHealth: "Health & Pharma",
      flyoutSports: "Sports Equipment",
      flyoutLogistics: "Logistics & Transport",
      flyoutHardware: "Hardware & Tools",
      flyoutServices: "Corporate Services",
      flyoutTech: "Technology & Electronics"
    },
    topbar: {
      phone: "+58 414 124 5080",
      email: "info@salotrading24.com",
      instagram: "Follow us on Instagram",
      hqBadge: "Caracas & Miami",
      schedule: "Mon - Fri: 8:00 AM - 5:00 PM",
      corpBadge: "Wholesale Commercialization & Distribution",
      switchLangText: "Español",
      navCta: "Initiate Partnership"
    },
    hero: {
      badge: "INTERNATIONAL COMMERCE SINCE 2009",
      headlinePrefix: "Global Commerce,",
      headlineHighlight: "Strategic Solutions",
      subheadline: "SALO TRADING 24 connects high-demand markets commercializing strictly legal goods across critical business sectors with strategic presence in the Americas, Asia, Africa, and the Middle East.",
      ctaPrimary: "Initiate Business",
      ctaSecondary: "Explore Organization",
      mapTitle: "Global Supply Routes",
      mapSub: "TRANSCONTINENTAL LOGISTICS NETWORK",
      stats: [
        { value: "2009", label: "Foundation Year", sub: "Over 17 years of trade leadership" },
        { value: "6", label: "Global Regions", sub: "Americas, Asia, Africa & Middle East" },
        { value: "35+", label: "Brands & Partners", sub: "Duracell, Gillette, P&G, Nestlé & more" },
        { value: "100%", label: "Legal Trade", sub: "Strict compliance standards" }
      ],
      nodes: {
        caracas: { name: "Caracas (Main HQ)", desc: "Corporate headquarters and distribution center for Venezuela & the Caribbean." },
        miami: { name: "Miami (Representative Office)", desc: "Logistics hub for North American alliances and international trade." },
        canada: { name: "Canada", desc: "Bilateral trade in consumer goods and industrial technology." },
        eastAsia: { name: "East Asia (Japan / Korea)", desc: "High-end tech hardware and precision manufacturing partnerships." },
        southeastAsia: { name: "Southeast Asia", desc: "Direct sourcing of electronics, components, and retail goods." },
        middleEast: { name: "Middle East", desc: "Transcontinental financial exchange and commodities trade." },
        africa: { name: "Africa", desc: "Emerging market trade in consumer goods and raw materials." }
      }
    },
    about: {
      badge: "COMPANY PROFILE",
      title: "About Us",
      leadParagraph: "SALO TRADING 24 began its operations in 2009, when our President, Menahem Truzman, founded the organization with the aim of commercializing all kinds of products in the food, services, health, sports, transportation, hardware and other sectors, all of legal trade.",
      locationsTitle: "International Headquarters & Presence",
      locationsDesc: "Our main headquarters are located in Caracas, Venezuela. We maintain a strategic representative office in Miami, USA.",
      hqCard: {
        title: "Main Headquarters (Caracas)",
        address: "CC Galerías Sebucán, Terraza 2, local 3. Transversal 10 con Av. Los Chorros, Urb. Los Dos Caminos. Caracas 1071, Venezuela.",
        badge: "Corporate Central Office",
        base: "Distribution Base: Venezuela & the Caribbean"
      },
      miamiCard: {
        title: "Representative Office (Miami)",
        address: "Miami, Florida, United States. Coordination hub for northern hemisphere and transatlantic trade.",
        badge: "North America Trade Hub",
        base: "North American Allies: United States & Canada"
      },
      pillarsTitle: "Strategic Corporate Framework",
      missionTitle: "Mission",
      missionDesc: "Provide services and solutions that meet the needs of our customers efficiently.",
      visionTitle: "Vision",
      visionDesc: "Position ourselves among the main importers of goods and services for Venezuela and the Caribbean, through strategic alliances with manufacturers and suppliers of manufacturing products under strict criteria of excellence and high quality standards.",
      valuesTitle: "Ethical Values",
      values: [
        { title: "Ethical Conduct", desc: "Integrity, honesty, commitment and responsibility across every commercial operation." },
        { title: "Customer Satisfaction", desc: "Constant dedication to exceeding the requirements of our buyers and corporate allies." },
        { title: "Achievement Orientation", desc: "Unwavering commitment to quality, operational efficiency, and safety standards." },
        { title: "Teamwork", desc: "Collaborative synergy between employees, commercial partners, and manufacturers." },
        { title: "Social Responsibility", desc: "Commitment to our collaborators, local communities, and environmental sustainability." }
      ]
    },
    structure: {
      badge: "GOVERNANCE & OPERATIONS",
      title: "Organizational Structure",
      subtitle: "A dynamic and streamlined leadership model tailored for commercial agility and operational excellence.",
      modalPrompt: "Click on any department to view corporate mandates.",
      president: {
        badge: "Executive Leadership",
        role: "President & Founder",
        name: "Menahem Truzman",
        desc: "Founder and strategic leader of SALO TRADING 24 since 2009. Overseeing global relations and international expansion alliances.",
        details: "Strategic decision making, multinational alliance negotiation, corporate governance, and overseeing continental trade expansion."
      },
      assistant: {
        role: "Executive Assistant",
        desc: "Executive coordination, institutional liaisons, and senior management resolution tracking.",
        details: "Bilateral agenda scheduling, fluid liaison between Caracas HQ and Miami office, tracking resolutions and operational audits."
      },
      departments: [
        {
          role: "Purchasing",
          title: "International Procurement",
          desc: "Negotiations with worldwide manufacturers, sourcing of raw materials & finished products, customs clearance and logistics control.",
          details: "Vendor vetting for Fortune 500 brands (Duracell, Gillette, P&G, Nestlé, Sony), tariff handling, origin quality inspection, and air/ocean freight coordination."
        },
        {
          role: "Sales",
          title: "Sales & Commercialization",
          desc: "National and international distribution networks, new commercial channel onboarding, client relations and corporate trade.",
          details: "Placement across retail chains, wholesale distribution networks in Venezuela and the Caribbean, key account retention, and market expansion."
        },
        {
          role: "Administration",
          title: "Administration & Finance",
          desc: "Accounting management, treasury, fiscal compliance, legal audits, and working capital optimization.",
          details: "Strict compliance with international and domestic trade law, tax regulations, independent accounting audits, and human capital administration."
        }
      ]
    },
    csr: {
      badge: "CORPORATE SOCIAL RESPONSIBILITY",
      title: "Responsibility Policy",
      lead: "We strongly believe that SALO TRADING 24 can and should have a positive impact on the communities we serve. It is our vision that together we will lift our partners, customers, suppliers and neighbors to create positive change in the areas where we can have the greatest impact:",
      focusAreas: [
        {
          icon: "leaf",
          title: "Leading in sustainability",
          desc: "Our aspiration is to become positive resources, giving more than what we take through conscious corporate practices."
        },
        {
          icon: "users",
          title: "Strengthening Communities",
          desc: "We seek to be a welcoming place for all by promoting volunteerism in our neighborhoods to support families."
        },
        {
          icon: "sparkles",
          title: "Creating opportunities",
          desc: "We invest in paths to opportunities through education, training and employment, supporting our human talent to build their future."
        }
      ],
      pyramidTitle: "Social Responsibility Pyramid Hierarchy",
      pyramidSubtitle: "Structural tier of ethical accountability and socio-economic impact (Based on official corporate policy)",
      pyramidLevels: [
        {
          level: 5,
          tier: "Level 5 (Apex)",
          name: "Design / Execution of State Policies",
          desc: "Strategic alignment with national economic goals, food security, supply-chain resilience, and collaborative state-level public-private policies.",
          color: "#E28B00"
        },
        {
          level: 4,
          tier: "Level 4",
          name: "Community Engagement",
          desc: "Direct grassroots outreach: corporate volunteering, humanitarian aid, local development projects, and partnerships with vocational training centers.",
          color: "#F2B822"
        },
        {
          level: 3,
          tier: "Level 3",
          name: "Family Projection",
          desc: "Welfare programs extended to employees' families: healthcare coverage, educational scholarships, and family economic stability.",
          color: "#F6D638"
        },
        {
          level: 2,
          tier: "Level 2",
          name: "Personal & Human Development",
          desc: "Continuous technical training, ergonomic workplace safety, career development, absolute respect for labor dignity, and leadership cultivation.",
          color: "#29B6F6"
        },
        {
          level: 1,
          tier: "Level 1 (Fundamental Foundation)",
          name: "Legal & Regulatory Compliance",
          desc: "The uncompromised foundation of all operations: absolute lawfulness, transparent tax and customs compliance, and adherence to international trade law.",
          color: "#0288D1"
        }
      ]
    },
    sectors: {
      badge: "COMMERCIAL DIVERSIFICATION",
      title: "Business Sectors",
      subtitle: "Commercializing a comprehensive range of high-demand, strictly legal goods across seven strategic sectors:",
      verifiedBadge: "Lawful Commerce Verified",
      items: [
        {
          code: "01",
          name: "Food & Beverage Sector",
          desc: "Packaged foods, beverages, canned goods, and consumer staples from recognized global manufacturers known for quality and freshness.",
          icon: "shopping-bag"
        },
        {
          code: "02",
          name: "Health & Medical Sector",
          desc: "Hospital supplies, surgical consumables, diagnostic instruments, and personal hygiene/care products.",
          icon: "heart-pulse"
        },
        {
          code: "03",
          name: "Sports & Athletic Sector",
          desc: "High-performance athletic gear, footwear, apparel, balls, and specialized training equipment.",
          icon: "trophy"
        },
        {
          code: "04",
          name: "Transportation & Fleet",
          desc: "Automotive spare parts, mechanical consumables, industrial tires, and fleet management supplies.",
          icon: "truck"
        },
        {
          code: "05",
          name: "Hardware & Tools",
          desc: "Manual and power tools, industrial fasteners, construction hardware, wiring, and general industrial maintenance goods.",
          icon: "wrench"
        },
        {
          code: "06",
          name: "Corporate Services",
          desc: "Commercial brokerage, international procurement consultancy, customs facilitation, and end-to-end supply chain orchestration.",
          icon: "briefcase"
        },
        {
          code: "07",
          name: "Technology & Electronics",
          desc: "Cutting-edge audio, display technology, smart home devices, digital imaging, and consumer electronics.",
          icon: "tv"
        }
      ]
    },
    markets: {
      badge: "INTERNATIONAL FOOTPRINT",
      title: "Main Markets & Global Reach",
      subtitle: "Import routes, distribution channels, and strategic relationships across four continents:",
      alliesNorthAmericaTitle: "Your Allies in North America",
      alliesNorthAmericaDesc: "Direct ties with the United States and Canada, enabling frictionless access to top-tier northern hemisphere distribution centers and manufacturers.",
      southAmericaTitle: "We Are Also in South America",
      southAmericaDesc: "Our primary operational headquarters in Caracas, Venezuela, serving as an agile logistics launchpad for the Andean and Caribbean regions.",
      routesBadgeNorth: "USA ⇄ CANADA ⇄ LATAM",
      routesBadgeSouth: "VENEZUELA & THE CARIBBEAN",
      regions: [
        { name: "Canada", desc: "Bilateral trade, consumer products, and industrial equipment sourcing.", code: "CA" },
        { name: "South America", desc: "Operational headquarters in Venezuela with Caribbean basin coverage.", code: "SA" },
        { name: "Southeast Asia", desc: "Advanced manufacturing, tech hardware, and electronic components.", code: "SEA" },
        { name: "Africa", desc: "Emerging consumer markets, raw materials, and agricultural goods exchange.", code: "AF" },
        { name: "Middle East", desc: "Transcontinental trade hubs, logistics centers, and commodities brokerage.", code: "ME" },
        { name: "Eastern Asia", desc: "Manufacturing partnerships in Japan, Korea, and leading regional hubs.", code: "EA" }
      ]
    },
    suppliers: {
      badge: "BRAND ALLIANCES & PARTNERS",
      title: "Our Suppliers & Brands",
      statement: "We have had successful business relationships with Duracell and Gillette Venezuela. Our expansion plan includes expanding our network, in that sense, we initiate contact with large local and international marketers which handle products from brands such as: Nestlé, Del Monte, Procter & Gamble, Fuji, JBL, Nike, Adidas, Canon, Crayola, among many others.",
      tickerTitle: "GLOBAL BRANDS & COMMERCIAL ALLIANCES IN OUR PORTFOLIO",
      allBrands: [
        "Duracell", "Gillette Venezuela", "Procter & Gamble", "Nestlé", "Del Monte",
        "Sony", "Canon", "Nikon", "JBL", "Panasonic", "Philips", "Apple", "Dell",
        "Bose", "Samsung", "LG Electronics", "Nike", "Adidas", "Bosch", "Caterpillar",
        "Fujifilm", "Toshiba", "Hisense", "Casio", "Yamaha", "Crayola", "Pioneer",
        "Polaroid", "Denon", "Kenwood", "Olympus", "Westinghouse", "Harman/Kardon"
      ]
    },
    blog: {
      badge: "MARKET INSIGHTS & REPORTS",
      title: "Posts & Publications",
      subtitle: "Technology coverage, international trade show reports, and global industry breakthroughs.",
      categoryTag: "Trends & Technology",
      readArticle: "Read Complete Report",
      post: {
        date: "December 13, 2021",
        title: "What's new at CES 2021",
        excerpt: "The first all-digital CES® 2021 opened its full virtual experience to global audiences, revealing firsthand the breakthrough innovation and technologies advancing the planet.",
        introP1: "The first-ever all-digital CES® 2021 opened its full virtual experience to audiences worldwide, showcasing firsthand the innovations and technologies destined to drive global progress.",
        introP2: "CES 2021 featured over 1,900 exhibitors representing the entire technological spectrum alongside more than 100 industry keynote sessions setting future visions.",
        subheading: "In-depth summary of the most prominent breakthroughs showcased by leading brands:",
        brandsList: [
          { name: "Bosch", desc: "Demonstrated sustainability commitments as the first global industrial corporation to achieve carbon neutrality, alongside an AI-powered wearable fitness sensor." },
          { name: "Canon", desc: "Revealed company initiatives expanding beyond imaging, redefining planetary surveillance, skateboarding technology, and combating food waste." },
          { name: "Caterpillar", desc: "Unveiled command applications for autonomous mining haul trucks operating in extreme industrial environments." },
          { name: "Hisense", desc: "Introduced the TriChroma 2021 laser television flagship lineup." },
          { name: "Indy Autonomous Challenge", desc: "Debuted the world's first fully autonomous race car, competing for a $1.5M grand prize across 500+ university engineers." },
          { name: "Intel / Mobileye", desc: "Announced mobility center deployment in Shanghai, Tokyo, Paris, and Detroit, incorporating in-house developed LiDAR technology." },
          { name: "Kohler", desc: "Introduced ceiling-mounted touchless kitchen faucets and sub-cabinet whole-home water intelligence systems." },
          { name: "LG Electronics", desc: "Unveiled LG PuriCare™ air systems, craft ice refrigerators, WashTower™ AI laundry, OLED evo and QNED MiniLED panels, and the CLOi UV-C sanitizing robot." },
          { name: "Magna International", desc: "Announced strategic joint venture with LG to manufacture electric powertrain motors for top automotive OEMs." },
          { name: "Mercedes-Benz", desc: "Debuted the MBUX Hyperscreen, utilizing AI for seamless driver and passenger contextual infotainment." },
          { name: "OMRON Healthcare", desc: "Launched VitalSight, the first comprehensive remote patient tele-monitoring service dedicated to hypertension management." },
          { name: "Panasonic", desc: "Announced tech partnerships with Illuminarium Experiences for 360-degree immersive theaters, alongside the JZ2000 OLED TV." },
          { name: "Philips", desc: "Showcased AI health-tech vision, including the Philips Sonicare 9900 Prestige toothbrush powered by SenseIQ predictive AI." },
          { name: "Samsung Electronics", desc: "Introduced the modular 4-door Flex Bespoke refrigerator, JetBot 90 AI+ vacuum, eco-friendly packaging, and Galaxy Upcycling at Home." },
          { name: "Schneider Electric", desc: "Presented the Square D Energy Center, connected switches, and Acti9 Active for resilient residential power management." },
          { name: "Skyworth", desc: "Debuted its North American 2021 display line across 5 series and 16 configurations." },
          { name: "Sony", desc: "Unveiled the Airpeak professional imaging drone, alongside an immersive VR music concert experience on PlayStation VR." },
          { name: "Taiwan Tech Arena", desc: "Featured 100 high-growth startups across Smart Living, Tech for Good, Cybersecurity, Health, and Mobility." },
          { name: "TCL", desc: "Announced OD Zero™ Mini-LED display panels, its inaugural Google TV line, NXTPAPER tablets, and TCL 20 5G smartphones." }
        ]
      }
    },
    contact: {
      badge: "GLOBAL INQUIRIES & OPERATIONS",
      title: "Contact & Headquarters",
      subtitle: "Ready to establish trade relations? Connect directly with our executive sales and logistics team.",
      formTitle: "Send Us a Message",
      nameLabel: "Full Name / Organization *",
      namePlaceholder: "Enter your name or business identity",
      emailLabel: "Corporate Email *",
      emailPlaceholder: "your.email@company.com",
      phoneLabel: "Phone / WhatsApp",
      phonePlaceholder: "+1 305 000 0000",
      subjectLabel: "Subject / Commercial Interest",
      subjectOptions: [
        "Food & Beverage Commerce",
        "Healthcare & Medical Supplies",
        "Technology & Consumer Electronics",
        "Sports & Apparel Distribution",
        "Transportation & Hardware",
        "Supplier / Manufacturer Alliance",
        "General Commercial Inquiry"
      ],
      messageLabel: "Message *",
      messagePlaceholder: "Specify your commercial requirement, estimated volumes, or partnership proposal...",
      submitBtn: "Send Message",
      sendingBtn: "Processing...",
      successMsg: "Thank you for reaching out to Salo Trading 24! Your inquiry has been received. Our team will get back to you shortly.",
      cards: {
        hqTitle: "Main Headquarters (Caracas)",
        hqAddress: "CC Galerías Sebucán, Terraza 2, local 3. Transversal 10 con Av. Los Chorros, Urb. Los Dos Caminos. Caracas 1071, Venezuela.",
        miamiTitle: "Representative Office (Miami)",
        miamiAddress: "Miami, Florida, United States.",
        phoneTitle: "Direct Telephone Line",
        phoneValue: "+58 414 124 5080",
        emailTitle: "Corporate Email",
        emailValue: "info@salotrading24.com",
        instagramTitle: "Social Media",
        instagramValue: "@salotrading24",
        whatsappBtn: "Direct WhatsApp Message",
        mapsLinkText: "View on Google Maps"
      },
      floatingWhatsApp: "Trade Inquiry? Chat via WhatsApp"
    },
    sitemapAudit: {
      badge: "TECHNICAL AUDIT & RECTIFIED ARCHITECTURE",
      title: "Comprehensive Sitemap Rectification",
      subtitle: "Decommissioning the 7-year-old WordPress bloat in favor of a clean, canonical 2026 bilingual index.",
      comparisonTitle: "Legacy WordPress vs. Rectified 2026 Solution",
      legacyColTitle: "Legacy Sitemap (WordPress 2019-2021) [Purged]",
      legacyIssues: [
        "Over 60 zombie demo pages indexing from Impreza theme (/elements/accordion, /portfolio-grid-4, /shop-without-sidebar, /tablepress-tables, /pagina-ejemplo).",
        "Disjointed en.salotrading24.com subdomain running duplicate 'noindex' headers with broken links.",
        "Zero structured Schema.org organization microdata.",
        "Missing centralized index of genuine commercial trading operations."
      ],
      rectifiedColTitle: "Rectified 2026 Sitemap [Production Live]",
      rectifiedFeatures: [
        "Zero junk URLs: strictly canonical routes for Spanish and English.",
        "Valid hreflang annotations (es, en, x-default) for international trade discoverability.",
        "Clean, standards-compliant sitemap.xml and robots.txt in the root directory.",
        "100% of the historical corporate content preserved and elevated with high-end editorial clarity."
      ],
      canonicalUrlsTitle: "Authoritative Canonical Routes",
      table: [
        { route: "/", descEs: "Inicio / Visión General de Salo Trading 24", descEn: "Home / Executive Overview", priority: "1.0" },
        { route: "/quienes-somos", descEs: "¿Quiénes Somos?, Historia, Sedes, Misión, Visión, Valores", descEn: "About Us, Origins, HQ, Mission, Vision, Values", priority: "0.9" },
        { route: "/quienes-somos#estructura", descEs: "Organigrama y Estructura Operativa", descEn: "Governance & Organizational Chart", priority: "0.85" },
        { route: "/quienes-somos#responsabilidad", descEs: "Política RSE y Pirámide de 5 Niveles", descEn: "CSR Policy & 5-Tier Pyramid", priority: "0.85" },
        { route: "/sectores", descEs: "7 Sectores Comerciales y Bienes de Lícito Comercio", descEn: "7 Business Sectors & Legal Commerce Goods", priority: "0.85" },
        { route: "/mercados", descEs: "6 Mercados Globales y Alianzas Norte/Suramérica", descEn: "6 Global Markets & Continental Alliances", priority: "0.85" },
        { route: "/proveedores", descEs: "Ecosistema de 35+ Marcas y Relaciones Comerciales", descEn: "Brand Ecosystem & Commercial Network", priority: "0.8" },
        { route: "/publicaciones", descEs: "Publicaciones / Novedades CES 2021 Completo", descEn: "Insights / CES 2021 Tech Report", priority: "0.75" },
        { route: "/contacto", descEs: "Sedes Caracas y Miami, Formulario y WhatsApp", descEn: "Caracas HQ, Miami Office, Contact Portal", priority: "0.9" },
        { route: "/sitemap.xml", descEs: "Archivo XML de Indexación para Motores de Búsqueda", descEn: "Search Engine Canonical XML Index", priority: "N/A" }
      ],
      xmlBtn: "View Official sitemap.xml",
      robotsBtn: "View Official robots.txt"
    },
    footer: {
      tagline: "Leading international trade and distribution firm for lawful goods. Founded in 2009 by President Menahem Truzman.",
      quickLinksTitle: "Quick Navigation",
      companyTitle: "The Organization",
      contactTitle: "Customer Care",
      legalTitle: "Lawful Trade Guarantee",
      legalText: "SALO TRADING 24 operates under strict international customs compliance, fiscal transparency, and global commerce regulations.",
      copyright: "© 2009 - 2026 SALO TRADING 24. All rights reserved.",
      devCredit: "Redesigned to 2026 editorial standards. Preserving 100% of original corporate content.",
      complianceBadge: "Verified Compliance 2026"
    }
  }
};
